import React, { useEffect, useState } from 'react';
import './dialogs.scss';
import { Simulate } from 'react-dom/test-utils';
import load = Simulate.load;

interface DialogsProps {
  header: string;
  content?: any;
  setChatId: Function;
  count: number;
  update: Function;
  scrollTop: Function;
  loading?: boolean;
  error?: boolean;
  retry?: () => void;
}

const QuantityMessages = ({ chat }) => {
  const [quantity, setQuantity] = useState<number | string>('');
  useEffect(() => {
    const result = chat.messages.filter((message) => !message.isRead);
    setQuantity(result.length);
  }, []);
  return <div className="dialogs__item__header--quantity">{quantity}</div>;
};

const Dialogs = ({
  header,
  content,
  setChatId,
  scrollTop,
  loading,
  error,
  retry,
}: DialogsProps) => {
  const openChat = (chat) => {
    setChatId(chat);
  };

  const handleScroll = (e) => {
    let element = e.target;
    if (
      !loading &&
      element.scrollTop + element.clientHeight >= element.scrollHeight - 30
    ) {
      scrollTop();
    }
  };

  return (
    <div className="dialogs">
      <div className="dialogs__header">{header}</div>
      {error && (
        <div role="alert">
          Не удалось обновить диалоги.{' '}
          <button onClick={retry} disabled={loading}>
            Повторить
          </button>
        </div>
      )}
      <div className="dialogs__items" onScroll={handleScroll}>
        {loading && (
          <div className="loading">
            <div className="loading__label">Загрузка...</div>
          </div>
        )}

        {content &&
          content.map((chat) => {
            return (
              <div
                className="dialogs__item"
                key={chat.id}
                onClick={() => openChat(chat)}
              >
                <div className="dialogs__item__header">
                  <div className="dialogs__item__header--name">
                    {chat.user.legal
                      ? `${chat.user.responsible}`
                      : `${chat.user.surname} ${chat.user.username} ${chat.user.patronymic}`}
                  </div>
                  {/*<QuantityMessages chat={chat} />*/}
                </div>
                <div className="dialogs__item__message">
                  {chat.messages?.[0]?.message ||
                    (chat.messages?.[0]?.file ? 'Вложение' : 'Нет сообщений')}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Dialogs;
